export default __webpack_public_path__ + "static/shape_round-db17319dc0f400530c36b9566a0fca58.png";